import * as Sentry from '@sentry/vue';

export function initSentry(app, router = null) {

    // keep YYYYMMDDHHMM


    // Try to get environment from VITE_ prefixed vars, or detect from URL
    const environment = import.meta.env.VITE_APP_ENV || 
                       import.meta.env.MODE || 
                       (window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1') ? 'local' : 'production');

    // Don't initialize Sentry in local development
    if (environment === 'local' || environment === 'staging') {
        // Do nothing!
    }

    

    try {
        Sentry.init({
            app,
            dsn: "https://32554465b6a740f101d78416ca3fb7f4@o4509547062099968.ingest.de.sentry.io/4509547070423120",
            // dsn: "https://bf98b13239114eacd95d3060600eb34c@o4509547062099968.ingest.de.sentry.io/4509547064721488",
            // release: 'tpj-vuejs', // manually set release here
            environment: environment,

            integrations: [
                /*
                Sentry.browserTracingIntegration({
                    tracePropagationTargets: ['localhost', 'www.tennispadeljobs.it', 'livedev.tennispadeljobs.it', /^\//],
                }),
                */
               Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                mask: ['input[type="password"]', '.sentry-mask', '[data-sentry-mask]', '[name="userpassword"]']
               })
            ],
            // tracesSampleRate: 0,
            // Session Replay
            replaysSessionSampleRate: environment === 'local' ? 1.0 : 0.1, // 100% in local, 10% in production
            replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });

        console.log('Sentry initialized');
    } catch (e) {
        console.error("Failed to initialize Sentry", e);
    }
}


